export default {
      id: "car_-usage",
      viewBox: "0 0 39 30",
      url: __webpack_public_path__ + "img/icons.svg#car_",
      toString: function () {
        return this.url;
      }
    }